import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getClientConfig, pageTypeConfig } from "../../config/app";

export function setCookie(data: string, exdays: number, clientId: string) {
  // const d = new Date();
  // d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  // console.log("clientId in setcookie", clientId);
  const clientConfig = getClientConfig(clientId);
  // console.log("clientConfig in setcookie", clientConfig);
  let expires = "expires=" + new Date(exdays).toUTCString()
  document.cookie = data + ";" + expires + ";path=/";
  //document.cookie = `${data}; ${expires}; path=/; domain=${clientConfig?.domain}; secure; HttpOnly SameSite=Lax`;
}

export function removeCookie(data: string, exdays: number, clientId: string) {
  // console.log("clientId in setcookie", clientId);
  const clientConfig = getClientConfig(clientId);
  // console.log("clientConfig in setcookie", clientConfig);
  let expires = "expires=" + new Date(exdays).toUTCString()
  document.cookie = `${data}; ${expires}; path=/; domain=${clientConfig?.domain}; secure; HttpOnly SameSite=Lax`;
  // Host-only copy (no domain attribute), e.g. lastState/user set by the SDK on this host.
  document.cookie = `${data}; ${expires}; path=/`;
}

export function getCookie(key: string) {
  let name = key + "=";
  let ca = document.cookie?.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c?.charAt(0) === " ") {
      c = c?.substring(1);
    }
    if (c?.indexOf(name) === 0) {
      return c?.substring(name?.length, c?.length);
    }
  }
  return "";
}

const Token = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Tokens (app.at / app.rt) are now set by the server as HttpOnly cookies.
    // Only return_url may be present here; validate it against pageTypeConfig.
    const returnUrl = searchParams.get("return_url");
    if (returnUrl && returnUrl in pageTypeConfig) {
      navigate(`/${returnUrl}`);
    } else {
      navigate("/");
    }
  }, [searchParams]);

  return <div></div>;
};

export default Token;
